import scopeCss from 'scope-css'

// Once it breaks we need to come up with a more sophisticated solution.
// Also strips block comments
export default function CustomCss({ src = '' }) {
  return src ? <style dangerouslySetInnerHTML={{ __html: scopeCss(src, '.body') }} /> : null
}
